import * as React from 'react'

import { BaseEventModel } from 'app/models/baseEventModel'
import { WeeklyReducedRestEventModel } from 'app/models/weeklyRegularRestModel'

import { useScene } from '../context/SceneContext'
import { useRestLanes } from '../context/LanesContext'
import { BOTTOM_PADDING } from '../utils/layout'

const color = '#F2C200'

export type WeeklyReducedRestBlockProps = {
  weeklyReducedRest: WeeklyReducedRestEventModel
  index: number
}

const prepareTooltipInfo = (
  weeklyReducedRest: WeeklyReducedRestEventModel,
): BaseEventModel => {
  const info: BaseEventModel = {
    startTime: weeklyReducedRest.startTime,
    endTime: weeklyReducedRest.endTime,
    typeName: 'eventName.weeklyReducedRest',
    color: color,
  }
  return info
}

export const WeeklyReducedRestBlock: React.FC<WeeklyReducedRestBlockProps> =
  React.memo((props: WeeklyReducedRestBlockProps) => {
    const scene = useScene()
    const { restLaneFor, restIsTop } = useRestLanes()
    const weeklyReducedRest = props.weeklyReducedRest


    if (scene.days > 1) {
      return null
    }

    const width = scene.widthOf(
      weeklyReducedRest.startTime,
      weeklyReducedRest.endTime,
    )
    const left = scene.timeToX(weeklyReducedRest.startTime)
    const lane = restLaneFor(
      weeklyReducedRest.startTime,
      weeklyReducedRest.endTime,
    )
    const isTop = restIsTop(
      weeklyReducedRest.startTime,
      weeklyReducedRest.endTime,
    )

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          position: 'absolute',
          left,
          top: 0,
          bottom: 0,
          paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div
          style={{
            background: color,
            borderColor: '#000000',
            pointerEvents: 'auto',
            width,
            height: 6,
            marginBottom: lane * 6,
            borderTopLeftRadius: isTop ? 3 : 0,
            borderTopRightRadius: isTop ? 3 : 0,
          }}
          data-tip={JSON.stringify(prepareTooltipInfo(weeklyReducedRest))}
          data-for="eventTooltip"
        />
      </div>
    )
  })

WeeklyReducedRestBlock.displayName = 'WeeklyReducedRestBlock'
